// Saisie libre d'un montant en euros (T-530 : capital social du délégataire).
// Accepte « 12 345,67 », « 12345.67 », « 12.345,67 », « 12 345,67 € », espaces
// insécables compris. Renvoie null pour une saisie vide, NaN pour une saisie
// illisible (l'appelant refuse d'enregistrer).

import { entierFR } from "./formatNombre";

export function lireMontantSaisi(saisie) {
  if (saisie === null || saisie === undefined) return null;
  if (typeof saisie === "number") return Number.isFinite(saisie) ? saisie : NaN;
  let s = String(saisie).replace(/[\s\u00a0\u202f€]/g, "");
  if (s === "") return null;
  const virgule = s.lastIndexOf(",");
  const point = s.lastIndexOf(".");
  if (virgule !== -1 && point !== -1) {
    // Le dernier séparateur est le décimal, l'autre sépare les milliers.
    const milliers = virgule > point ? "." : ",";
    s = s.split(milliers).join("");
  } else if (point !== -1 && /^\d{1,3}(\.\d{3})+$/.test(s)) {
    // « 12.345 » ou « 1.234.567 » : points de milliers.
    s = s.split(".").join("");
  }
  s = s.replace(",", ".");
  if (!/^-?\d+(\.\d+)?$/.test(s)) return NaN;
  return parseFloat(s);
}

export function formaterMontantSaisi(montant) {
  if (montant === null || montant === undefined || montant === "") return "";
  const n = Number(montant);
  if (!Number.isFinite(n)) return "";
  // Espaces ordinaires : le texte reste éditable tel quel dans le champ.
  return entierFR(n, 2).replace(/[\u00a0\u202f]/g, " ");
}

// Capital fourni par la recherche d'entreprise, s'il y en a un.
// recherche-entreprises.api.gouv.fr ne renvoie aucun champ capital à ce jour
// (mesuré le 05/11/2026) : on lit les noms possibles et on renvoie null sinon.
export function capitalDepuisEntreprise(entreprise) {
  const e = entreprise || {};
  for (const v of [e.capital_social, e.capital, e.complements?.capital_social]) {
    const n = lireMontantSaisi(v);
    if (n !== null && !Number.isNaN(n)) return n;
  }
  return null;
}
